export default __webpack_public_path__ + "static/media/66.26a8fc4a.jpg";